// extracted by mini-css-extract-plugin
export default {"gradientText":"gradientText-c3b5","belongStandardsCard":"belongStandardsCard-f71b"};